// Extracts the numeric size (e.g. "42" from "42 (US M)") for filtering.
// Falls back to the trimmed raw label if no number is present.
export const sizeValue = (size) => {
  if (!size) return null;
  const m = String(size).match(/\d{2,3}/);
  return m ? m[0] : String(size).trim();
};

// Owner-confirmed chart: Indian size number → US / age equivalent.
export const SIZE_LABELS = {
  "22": "2 years", "24": "3-4 years", "26": "5-6 years", "28": "7-8 years",
  "30": "9-10 years", "32": "11 years", "34": "12 years", "36": "13 years",
  "38": "US XS", "40": "US SMALL", "42": "US M", "44": "US L", "46": "US XL",
  "48": "US XXL", "50": "US 3XL", "52": "US 4XL", "54": "US 5XL", "56": "US 6XL",
  "58": "US 7XL", "60": "US 8XL",
};

// Shopper-facing label: "N - equivalent". The owner's chart wins for the adult
// range (38-60: "40 (US S)" → "40 - US SMALL"). Smaller sizes keep their
// catalog parenthetical ("36 (US XXS)" → "36 - US XXS", "24 (4T)" → "24 - 4T"),
// plain small numbers use the chart's ages ("28" → "28 - 7-8 years").
// Anything else ("Free Size", "3XL", "2 years", "38/ Indian M…") passes through.
export const sizeLabel = (size) => {
  if (!size) return "";
  const raw = String(size).trim();
  const paren = raw.match(/^(\d{2})\s*\((.+)\)$/);
  const num = paren ? paren[1] : /^\d{2}$/.test(raw) ? raw : null;
  if (num && Number(num) >= 38 && SIZE_LABELS[num]) return `${num} - ${SIZE_LABELS[num]}`;
  if (paren) return `${paren[1]} - ${paren[2].replace(/\s+/g, " ").trim()}`;
  if (num && SIZE_LABELS[num]) return `${num} - ${SIZE_LABELS[num]}`;
  return raw;
};

// Sort helper: numeric sizes ascending, then any non-numeric labels alphabetically.
export const compareSizes = (a, b) => {
  const na = Number(a);
  const nb = Number(b);
  const aNum = !Number.isNaN(na);
  const bNum = !Number.isNaN(nb);
  if (aNum && bNum) return na - nb;
  if (aNum) return -1;
  if (bNum) return 1;
  return String(a).localeCompare(String(b));
};
